import R from 'ramda';
import moment from 'moment';
import { createSelector } from 'reselect';
import { selectUser } from './current_user';
import deprecated from '../deprecated';

import { param } from './utils';

// (root) => [ ...printJob ]
const selectPrintStoreRoot = root => root.print;

export const selectPrintJob = createSelector(
    selectPrintStoreRoot,
    param(1),
    (state, id) => state[id]
);
export const getPrintJob = deprecated(
    selectPrintJob,
    `Use selectPrintJob instead`
);

export const selectLastJob = createSelector(
    selectPrintStoreRoot,
    R.last
);

const publisherVomit = `
    Printing is for personal use only. No part of this eText may be reproduced
    or digitally transmitted for reasons other than personal use without the
    Publisher’s permission. Violators will be prosecuted.
`;

// (root, job) => string
export const selectWatermark = createSelector(
    param(1),
    root => selectUser(root),
    (job, user) => {
        const { content, pageList } = job;

        const pages = `${R.head(pageList).label}-${R.last(pageList).label}`;

        const today = moment().format('YYYY-MM-DD');

        return `
        Printed by ${user.full_name} ${user.email} on ${today}; from
        ${content.title} ${content.author_byline}, Page: ${pages}.
        ${content.is_courseload_administered ? publisherVomit : ''}
        `
            .split('\n')
            .join('');
    }
);



// WEBPACK FOOTER //
// ./src/selectors/print.js